import type { AppArea } from '../../utils/lastApp';

/**
 * A photo or sketch by its own address — `/media/<id>` — for pasting into a
 * mail or a ticket. A picture has no screen of its own: the address opens the
 * description it belongs to, scrolled to it and marked (see MediaRedirect).
 *
 * Neither app's prefix is in it: the link is opened by whoever receives it,
 * and their roles decide whether that is the office or the field app.
 */
export function mediaDirectPath(mediaId: string): string {
    return `/media/${mediaId}`;
}

export function mediaDirectUrl(mediaId: string): string {
    return `${window.location.origin}${mediaDirectPath(mediaId)}`;
}

/** The query parameter by which a description's dialog marks one picture. */
export const MEDIA_FOCUS_PARAM = 'media';

/**
 * The description's route in the given app, picking out the picture:
 * `/office/projects/P/diaries/D/edit#media` becomes
 * `/field/P/diaries/D/edit?media=<id>#media` in the field app. Both apps
 * mount the same dialogs under the same tails, only the prefix differs.
 */
export function mediaFocusPath(
    officePath: string,
    area: AppArea,
    mediaId: string
): string {
    const [route, anchor] = officePath.split('#');
    const inArea =
        area === 'field'
            ? route.replace(/^\/office\/projects\//, '/field/')
            : route;
    const separator = inArea.includes('?') ? '&' : '?';
    return (
        `${inArea}${separator}${MEDIA_FOCUS_PARAM}=${encodeURIComponent(mediaId)}` +
        (anchor ? `#${anchor}` : '')
    );
}
